<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
    <div>
        <div>
            <span class="pageHeader" id="viewTransmissionListHeader">
                View Transmission Status List
            </span>
        </div>
        <br>
        <div class="warningMessage" *ngIf="warningMessage">
            <li>{{warningMessage}}</li>
        </div>
        <div class="errorMessage" *ngIf="errorMessage?.length">
            You must correct the following error(s) before proceeding:
            <li *ngFor="let message of errorMessage">{{message}}</li>
        </div>
        <br>
        <div *ngIf="!showResult">
            <div class="page-hint sans-serif-font">
                1. Enter/select a date from the list. 2. Click on the Search button to view all transmissions for the
                selected
                month. 3. Click on the Cancel button to go to the previous page.
            </div>
            <div class="banner">
                Reverse Mortgage Transmission Search
            </div>
        </div>
    <div class="contents">
        <span class="adminTblAlign">
            <div class="horizontal-center glypha-font"> Search by month: </div>
            <div class="ui-g-2">
                <fm-select [options]="months" [(ngModel)]="month" ariaLabelledBy="default">
                </fm-select>
            </div>
        </span>
        <span class="adminTblAlign">
            <span class="horizontal-center glypha-font"> Search by date:
                <br><span class="TblAlign">MM/DD/YYYY</span></span>
            &nbsp; &nbsp; &nbsp;
            <div class="ui-g-3">
                <fm-calendar [(ngModel)]='date' [showClear]="true"> </fm-calendar>
            </div>
        </span>
        <span class="adminTblAlign">
            <div class="horizontal-center glypha-font">Search by user id:</div>
            <div class="ui-g-2"> <input type="text" maxlength="9" (keyup)="trackKeyPress($event)" [(ngModel)]='userId' fmTextInput></div>
        </span>
        <div class="btn-container">
            <button fmButton type="button" [small]="true" [primary]="true" label="Search"
                (click)="transmissionListSearch()" class="dispbuttonMargin"></button>
            <button fmButton type="button" routerLink="/reverseMortgage" [small]="true" label="Cancel"
                class="dispbuttonMargin"></button>
        </div>
    </div>
</div>
<br>
<div *ngIf="showResult" class="content-width">

  <div class="row u-ml-750">
    <div  class="download-button">
      <div class="select-style">
        <fm-select
          [options]="pageView"
          placeholder="Choose"
          [(ngModel)]="selectedPageView"></fm-select>
      </div>
      <button fmButton class="ok-button" type="button" [small]="true" label="Ok" (click)='pageViewAction(dt)'></button>
    </div>
  </div>
  <div class="transmission-status-result-container">
    <fm-table #dt [columns]="cols" [value]="transmissionDetails" [paginator]="true" [rows]="10" [compressed]="true"
        [autoLayout]="true" [rowsPerPageOptions]="[10,25,50]" [enableTableEntryTotal]="true">
        <ng-template fmTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" class="row-selection">{{col.header}}</th>
            </tr>
        </ng-template>
        <ng-template fmTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns" [style.width]="col.width">
                    {{rowData[col.field]}}
                </td>
            </tr>
        </ng-template>
    </fm-table>
  </div>
</div>
</div>
